import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'antd'
import MailProcessing from 'components/MailProcessing'
import { ArrowRight } from 'components/Icons'
import Mail from 'globals/models/Mail'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { MobileMailDetails, MobileMailWrapper, MobileMailProcess, MobileMailRef, MobileMailType } from './styles'

interface IProps {
  mail: Mail,
  selected: boolean,
  onChangeSelect: (e: CheckboxChangeEvent) => void,
  onClick: (mail: Mail) => void,
  mailRef: (mail: Mail) => ReactNode
}

const MobileMail = (props: IProps) => {
  const { mail, selected, onChangeSelect, onClick, mailRef } = props
  const { t } = useTranslation()

  return (
    <MobileMailWrapper
      selected={selected}
    >
      <Checkbox
        checked={selected}
        onChange={onChangeSelect}
      />

      <MobileMailDetails
        onClick={() => onClick(mail)}
      >
        <MobileMailRef>
          {mailRef(mail)}
        </MobileMailRef>

        <MobileMailType>
          {t('mails.types.'+ mail.mailType)}
        </MobileMailType>

        <MobileMailProcess>
          <MailProcessing
            processingType={mail.processingType}
            processingDate={mail.processingDate}
            customerRequest={mail.hasUserRequest}
          />
        </MobileMailProcess>
      </MobileMailDetails>

      <ArrowRight
        onClick={() => onClick(mail)}
      />
    </MobileMailWrapper>
  )
}

export default MobileMail
